import { Hub, HubManager } from 'src/app/pages/hubs/common/Hubs';

let self;

export class TMHub extends Hub {
  static RECORD_LOCKED: string = 'tmHubRecordLocked';
  static HUB_Name: string = 'TMHub';

  constructor(private hubManager: HubManager) {
    super();
    self = this;

    hubManager.hubManagerEvents.subscribe((value: any) => {
        if (value && value.eventName == 'CONNECTIONSTARTED') {
            if (!this.hubManager.getTMHubJoinedStatus()) {
                console.log('TMHub Joined');
                self.join();
                
            }
       
      }
    });
    // .CONNECTIONSTARTED.subscribe(res => {
    //   console.log('TMHub Joined');
    //   self.join();
    // });
  }
  //getNotification(evt) {
  //    self.join();
  //}
  //@InboundAttribute
  public recordLocked(client: string, recordLock: any) {
    //if (this.QBRSecurity().clientShortName() == client && recordLock.LockingUserID !== this.Security().user().UserID) {
    //    this.dispatchEvent(TMHub.RECORD_LOCKED, recordLock);
    //}
  }
}
